import { Component, Input } from '@angular/core';
import { IonicPage} from 'ionic-angular';

/**
 * Generated class for the GdxLoadingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'gdx-loading',
  templateUrl: 'gdx-loading.html',
})
export class GdxLoadingPage {
  @Input() color:any = 'outline';
  @Input() width:any;

  constructor() {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GdxLoadingPage');
  }

}



// WEBPACK FOOTER //
// ./src/components/gdx-loading/gdx-loading.ts